module.exports = __webpack_public_path__ + "static/media/hot_mxdsy.aecdd917.png";